import { createContext } from 'react';
export const defaultContext = {
    currentTabNumber: 1,
};
export const TabToggleSwitchContext = createContext(defaultContext);
